export default __webpack_public_path__ + "static/1606-96214f65009e04e42c54cf64bf40ebb3.gif";